import React, { Component } from 'react';
import { useImage } from 'react-image'
import {imagePath} from '../common'
export function SliderImageComponent(props) {
    const { src } = useImage({
        srcList:imagePath+ props.item.slider_image
    })
    return (
        <div className="inner-slide-show" key={props.index}>
            <div className="slide-grid" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}>
                <div className="container">
                    <div className="dec-cont">
                        <h3><span>{props.item.slider_title}</span></h3>
                        <p>{props.item.slider_description}</p>
                        <a className="hvr-outline-out button2" href="javascript:void(0)" onClick={()=> props.onClick(props.item.slider_collection)}>{props.item.slider_button}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}